import { render, staticRenderFns } from "./CameraPlayer.vue?vue&type=template&id=1a6b32ff&scoped=true"
import script from "./CameraPlayer.vue?vue&type=script&lang=ts"
export * from "./CameraPlayer.vue?vue&type=script&lang=ts"
import style0 from "./CameraPlayer.vue?vue&type=style&index=0&id=1a6b32ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b32ff",
  null
  
)

export default component.exports